@if ((reportingPeriodStateLoading$ | async) === false) {
  <div class="fpar-banner">
    @if (!submissionOpen && !validationOpen) {
      The data submission period is closed for any data submissions! Accepted
      data and previous year data submissions are available to view in the
      <span [routerLink]="['/table-archive']">Table Archive</span>.
    }
    @if (submissionOpen) {
      The data submission period is now open!
    }
    @if (!submissionOpen && validationOpen) {
      The Data Validation Explorer tool is available for testing and/or training 
      purposes only. It will remain available until the start of the submission 
      period. Please note you will not be able to edit any tables and data will 
      not be saved once the DVE tool is closed. You will need to resubmit your 
      complete files during the open submission period.
    }
  </div>
}
